/* eslint-disable */
import React, { Component } from 'react'; 
import HTMLText from '../UiComponent/HTMLText';
import  './FormPage.scss'
import Button from '../UiComponent/Button';
import CheckBox from '../UiComponent/CheckBox';
class FormConfirmationBox extends Component {
	constructor(props) {
		super(props);	
		this.state = {
			fMsg:this.props.labelText,
			info:this.props.raceInfo == null ? {} :this.props.raceInfo,
			personalInfo:this.props.personalInfo == null ? {}:this.props.personalInfo,
			confirm:[]
		};	
	}
    

    componentWillReceiveProps(nextProps) {
		this.setState({fMsg:nextProps.labelText,info:nextProps.raceInfo,personalInfo:nextProps.personalInfo});
	} 
	
	componentDidMount() {     
	}

	componentWillUnmount() {
	}
    
  

	render() {	
		var appliedRaceName = []
		if (this.state.personalInfo.selectedList && this.state.info.raceItem){
				var appliedRaceId = this.state.personalInfo.selectedList;
				appliedRaceId.forEach(element => {
					this.state.info.raceItem.forEach(race =>{	
						if (race.id == element){						
							appliedRaceName.push(race.nameZh +"<br/>" +race.nameEn);
						}
					});
				});			
		};		
	 var appliedRaceDisplay =	appliedRaceName.map((value, index) => 
		 <div key={index} className='prompt-race-name'><HTMLText text={value}/></div>	
		);
		
	if (this.state.info && this.state.info.optFieldDisplayLevel != null && this.state.info.optFieldOptionEn != null 
			&& this.state.info.optFieldOptionZh != null){
			var optFieldDisplayTypeArr = this.state.info.optFieldDisplayLevel && this.state.info.optFieldDisplayLevel.toUpperCase().split("|");		
			var displayOptField = false;
			const self = this;
			
			this.state.info.raceItem.forEach(function(item) {
				self.state.personalInfo.selectedList.forEach(function(race){
					if (race == item.id){
						if (optFieldDisplayTypeArr.includes(item.level.toUpperCase())){
							displayOptField = true;
						}
					}
				})
			});		
		}

		return (
      <React.Fragment>
		  <div className='confirmation-prompt'>
		  	<div className='table-div'>		
				<table className='confirmation-box-table'>
					<tbody>
					<tr className="row red">
							<td colSpan="2">
								<HTMLText text={this.state.fMsg.noticeZh+"<br/>" + this.state.fMsg.noticeEn }/>
							</td>							
						</tr>				
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.raceTitleZh+":<br/>" + this.state.fMsg.raceTitleEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.raceTitleZh +"<br/>" + this.state.info.raceTitleEn}/>
							</td>
						</tr>					
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.raceDateZh +":<br/>" + this.state.fMsg.raceDateEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.raceDateZh +"<br/>" + this.state.info.raceDateEn}/>
							</td>
						</tr>
					

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.raceTimeZh +":<br/>" + this.state.fMsg.raceTimeEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.raceTimeZh +"<br/>" + this.state.info.raceTimeEn}/>
							</td>
						</tr>
					
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.locationZh +":<br/>" + this.state.fMsg.locationEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.locationZh +"<br/>" + this.state.info.locationEn}/>
							</td>						
						</tr>		
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.feePerRaceZh +":<br/>" + this.state.fMsg.feePerRaceEn +":"}/>
							</td>
							<td>
								<HTMLText text={this.state.info.feePerRaceDescZh +
								"<br/>" + this.state.info.feePerRaceDescEn}/>		
							</td>
						</tr>			
						<tr >
							<td className="personal-info-title" colSpan='2'>
								<HTMLText text={this.state.fMsg.personalInfoTitleZh +"&nbsp;&nbsp;&nbsp;&nbsp;" + this.state.fMsg.personalInfoTitleEn}/>
							</td>					
						</tr>		
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.chiNameZh +":<br/>" + this.state.fMsg.chiNameEn +":"}/>
							</td>
							<td>	
								{this.state.personalInfo.chineseName}
							</td>
						</tr>
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.engNameZh +":<br/>" + this.state.fMsg.engNameEn +":"}/>
							</td>
							<td>	
								{this.state.personalInfo.englishName}								
							</td>
						</tr>
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.dobZh +":<br/>" + this.state.fMsg.dobEn +":"}/>
							</td>
							<td >
								{this.state.personalInfo.dobYear + "-" + this.state.personalInfo.dobMonth + '-' +this.state.personalInfo.dobDay}											
							</td>
						</tr>
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.idZh +":<br/>" + this.state.fMsg.idEn +":</span>"}/>
							</td>
							<td>	
								{this.state.personalInfo.id}		
							</td>
						</tr>

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.genderZh +":<br/>" + this.state.fMsg.genderEn +":"}/>
							</td>
							<td>
								{this.state.personalInfo.gender}													
							</td>
						</tr>
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.mobileZh +":<br/>" + this.state.fMsg.mobileEn +":"}/>
							</td>
							<td>	
								{this.state.personalInfo.mobile}	
							</td>
						</tr>

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.emailZh +":<br/>" + this.state.fMsg.emailEn +":"}/>
							</td>
							<td>	
							{this.state.personalInfo.email}	
							</td>
						</tr>
						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.guardianNameZh +":<br/>" + this.state.fMsg.guardianNameEn +":"}/>
							</td>
							<td>	
							{this.state.personalInfo.guardianName}	
							</td>
						</tr>

						<tr className="row">
							<td>
								<HTMLText text={this.state.fMsg.guardianMobileZh +":<br/>" + this.state.fMsg.guardianMobileEn +":"}/>
							</td>
							<td>	
							{this.state.personalInfo.guardianMobile}	
							</td>
						</tr>	
						<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.raceItemTitleZh +":<br/>" + this.state.fMsg.raceItemTitleEn+":"}/>
									</td>
									<td>
										{appliedRaceDisplay}	
									</td>	
						</tr>
						{displayOptField && (
							<tr className="row">
									<td>
										<HTMLText text={this.state.info.optFieldZh +"<br/>" + this.state.info.optFieldEn}/>
									</td>
									<td>
										<HTMLText text={typeof this.state.personalInfo.optField === 'string' 
											? this.state.personalInfo.optField 
											: Array.isArray(this.state.personalInfo.optField) 
											? this.state.personalInfo.optField.join(', ') 
											: this.state.personalInfo.optField}			/>						
									</td>	
							</tr>
						)}
							<tr className="row">
									<td colSpan={2}>	
										<CheckBox text={this.state.fMsg.confirmMsgZh +"<br/>" + this.state.fMsg.confirmMsgEn} dataField='confirm'
										parent={this} key='confirm-checkbox' value='1' curValue={this.state.confirm} name='confirm-checkbox' className='confirm-checkbox'/>
									</td>
									
						</tr>
										
					</tbody>
				</table>
            	</div>
				</div>
				<div className='twoButtonTd'>			
						<Button	className='submitButton defaultButton' onClickAction={()=> this.props.onCloseConfirmClicked()} text={this.state.fMsg.closeZh+"<br/>"+this.state.fMsg.closeEn}/>									
						{this.state.confirm.length>0 &&(
							<Button	className='submitButton defaultButton' onClickAction={()=> this.props.onConfirmClicked()} text={this.state.fMsg.confirmZh+"<br/>"+this.state.fMsg.confirmEn}/>
						)}

						{this.state.confirm.length == 0 &&(
							<Button	className='submitButton defaultButton dimButton' onClickAction={null} text={this.state.fMsg.confirmZh+"<br/>"+this.state.fMsg.confirmEn}/>
						)}
				</div>		
    </React.Fragment>
		);
	}
}

export default FormConfirmationBox;